<app-page-template
  [class.d-none]="isShowStrategies || isShowPointStrategies"
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [titleClass]="'tw-dir-rtl'"
  (sortObject)="getSortItems($event)"
  (onAdd)="onCreate()"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------- Audit btns ---------------------------------------->
  <div class="card-toolbar" before-btns>
    <!-- strategies btn -->
    <button
      (click)="onStrategies()"
      class="btn btn-light-info txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
    >
      <!-- [matTooltip]="'common.strategies' | translate" -->
      <!-- <i class="mdi mdi-strategy mdi-20px tw-p-0 text-info"></i> -->
      <span>{{ "common.strategies" | translate }}</span>
    </button>

    <!--point strategies btn -->
    <button
      (click)="onPointStrategies()"
      class="btn btn-light-blue txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
    >
      <!-- <i class="mdi mdi-scoreboard mdi-20px tw-p-0 text-gray"></i> -->
      <span>{{ "common.pointStrategies" | translate }}</span>
    </button>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- index -->
        <td>
          <span copyToClipboard>
            {{ item?.index | enumToText : UserValueOfPurchaseIndexEnumValues }}
          </span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete(item.index, '')"
            (onUpdate)="onUpdate(item, false)"
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--alert setting-->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-value-of-purchase-points-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-value-of-purchase-points-form>
</ng-container>

<!--strategies setting-->
<ng-container *ngIf="isShowStrategies">
  <app-value-of-purchase-strategies
    [formPageConfig]="formPageConfig"
    (closeFormPage)="isShowStrategies = false"
  >
  </app-value-of-purchase-strategies>
</ng-container>

<!--point strategies setting-->
<ng-container *ngIf="isShowPointStrategies">
  <app-value-of-purchase-point-strategies-form
    [pointPerIndexModel]="pointPerIndexModel"
    [allPossibleIndices]="allPossibleIndices"
    (closeFormPage)="isShowPointStrategies = false"
  >
  </app-value-of-purchase-point-strategies-form>
</ng-container>
